<template>
    <div class="organization">
    
      <v-row>
       
          <v-col cols="2">

            <v-card class="mx-auto" >                       
             
              <!-- <v-list v-model:opened="open" v-for="(item, i) in this.organizations" :key="i" > -->
              <v-list v-for="(item, i) in this.organizations" :key="i"  style="max-height: 1000px; max-width: 300px;" class="overflow-y-auto">  
                <!-- <v-list-item prepend-icon="mdi-home" title="Home"></v-list-item> -->
                WORKING
                <!-- EXCLUDED THE GLOBAL GROUP FROM THE LIST -->
                <!-- <v-list-group v-if="item.orgName != 'GLOBAL'" :value=item.orgName> -->
                <v-list-group  :value=item.orgName>
                  
                  <!-- <template v-slot:activator="{ props }">
                    <btn @click="getOrg(item.orgId)" >
                    <router-link :to="/device-org/+item.orgId">
                    <v-list-item
                      v-bind="props"                      
                      :title=item.orgName
                    ></v-list-item>
                    </router-link>
                  </btn>
                  </template> -->
                  <template v-slot:activator="{ props }">
                    
                    <router-link class="routerLink" :to="/device-org/+item.orgId">
                    <!-- <router-link class="routerLink" :to="/devices-list/+item.orgId">  --> 
                    <v-list-item
                      v-bind="props"                      
                      :title=item.orgName
                    ></v-list-item>
                    </router-link>
                  
                  </template>
                

                  <!-- <v-list-group  v-for="(item1, u) in item.acquirer" :key="u">
                    
                    <template v-slot:activator="{ props }">
                       <btn @click="getAcq(item1.acquirerId)" > 
                      <v-list-item
                        v-bind="props"
                        :title=item1.acquirerName
                      ></v-list-item>
                       </btn> 
                    </template>
                    

                    <btn @click="getDeviceDetails(item2.deviceId)" v-for="(item2, s) in item1.device" :key="s" >
                      <v-list-item               
                        :title=item2.deviceSN
                        :prepend-icon="icon"
                        :value=item2.deviceId
                        active-color="primary"
                        rounded="xl"
                      ></v-list-item>
                    </btn>
                    
                  </v-list-group> -->

                  
                  <!-- <btn  @click="getAcq(item1.acquirerId)" v-for="(item1, u) in item.acquirer" :key="u">
                      <router-link :to="/device-acquirer/+item1.acquirerId">
                      <v-list-item
                        v-bind="props"
                        :title=item1.acquirerName
                        :value=item1.acquirerId
                        :prepend-icon="icon"
                        active-color="primary"
                        rounded="xl"                        
                      ></v-list-item>
                    </router-link>
                  </btn>  -->

                  <btn v-for="(item1, u) in item.acquirer" :key="u">
                    <router-link class="routerLink" :to="/device-acquirer/+item1.id">
                    <!-- <router-link class="routerLink" :to="/devices-list/+item1.id"> -->
                      <v-list-item
                        v-bind="props"
                        :title=item1.acquirerName
                        :value=item1.id
                        :prepend-icon="icon"
                        active-color="primary"
                        rounded="xl"                        
                      ></v-list-item>
                    </router-link>
                  </btn> 

                  
                  
                </v-list-group>



              </v-list>
            </v-card>
                
          </v-col>       
          <v-col cols="10" class="overflow-x-auto">

            <v-row>
                
                <!-- <component v-bind:is="cmp"></component> -->                

                <!-- <router-view :key="$route.params[$route.meta.watchParam]" /> -->
                <router-view :key="$route.params[$route.meta.watchParam]" @reload="reloadChild"/>

            </v-row>

            <v-row>
              
            </v-row>
            
          </v-col>  

      </v-row>




      

      
    </div>
  </template>
  
  <script>
  import axios from 'axios'
  //import OrgDevices from '../components/OrgDevices.vue'
  //import AcqDevices from '../components/AcqDevices.vue'
  //import updateDevice2 from '../components/updateDevice2.vue'
  export default {
    name: 'DeviceDetails',
    components: {
      //OrgDevices, 
      //AcqDevices,
      //updateDevice2,
    },
    props: {
      msg: String      
    },
    data(){
      return {
        name: '', 
        //props: ['status'],     
        devices: [],  //used
        organizations: [],
        acquirers: [],

        dev_compoment: true,   //to be remove
        show_orgDevice: true,
        show_acqDevice: false,
        show_updateDevice: false,

        //cmp: OrgDevices,

        id: '',


        permissions: [],   
        
        dialog: false,
        dialog_update: false,
        dialog_delete: false,

        role_data:{  //used
          f_roleName: '',
          f_orgId: '',
          f_perList: [],
          
        },

        deviceId: '',       
        search: '',
        headers: [
        {
            title: 'Device SN',
            align: 'start',
            sortable: false,
            key: 'deviceSN',
          },
          { title: 'TID', key: 'tid' },
          { title: 'MID', key: 'mid' },
          { title: 'Currency', key: 'currencyName' },
          { title: 'Merchant Name', key: 'merchants.merchantName' },
          { title: 'Merchant Address', key: 'merchants.merchantAddress' },
          { title: 'Acquirer', key: 'merchants.acquirer.acquirerName' },
          //{ title: 'Date Created', key: 'dateCreated' },
          { title: 'Date Updated', key: 'dateUpdated' },          
          { title: 'Organization', key: 'merchants.acquirer.organization.orgName' },          
          //{ title: 'Actions', key: 'acquirerId', sortable: false },
          { title: 'Actions', key: 'actions', sortable: false },
        ],


        //FOR USER DATA
        user_roles: '',
        user_org: '',
        user_permissions:[],

        //snackbar
        snackbar: false,
        snackbar_text: '',
        snackbar_color: '',

        


      }
    },

    created () {
      
    },

    methods:{

      reloadChild(){
      //alert("hello guys")
      //console.log("id", "refreshing2 " + this.componentKey); 
      //this.componentKey += 1;
      
    },
      
      show_toast(status, color, text){
        this.snackbar = status
        this.snackbar_color = color
        this.snackbar_text = text;
      },
      
      getOrg(value){        
        // this.show_orgDevice = true
        // this.show_acqgDevice = false
        // console.log("Org", value +" / "+this.show_orgDevice)
         this.id = value
         //this.cmp = OrgDevices
         
      },

      getAcq(value){
        // console.log("Acq", value)        
        // this.show_orgDevice = false
        // this.show_acqDevice = true
        // console.log("Acq", value +" / "+this.show_acqDevice)
        this.id = value
        // console.log("Acq", this.id) 
        //this.cmp = AcqDevices
       // :to="/device-acquirer/+item1.acquirerId"
        //this.$router.push({name: 'AcqDevices', params: {value}})
        //this.$router.push({ path: '/device-acquirer/${this.id}' })
        
      },

      getDeviceDetails(value){
        //console.log("Acq", value)        
        this.show_orgDevice = false
        this.show_updateDevice = true
        // console.log("Device", value +" / "+this.show_updateDevice)
        this.id = value
      },
      
      async pullDataAdmin(result){   
        
        if(result.data.records != null && result.data.records.length > 0) {
            let i = 0;
            this.organizations = [];   //remove all items from array
            //let org_id;
            for(i=0; i<result.data.records.length; i++){                                                 
                
                // console.log("org_id", result.data.records[i].id);
                let result_acquirer = await axios.get(window.baseurl+""+"acquirers/org/"+result.data.records[i].id , 
                  {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
                );
                this.organizations.push({ orgId: result.data.records[i].id, orgName: result.data.records[i].orgName, acquirer: result_acquirer.data.records });
                // console.log("acquirers_object", result_acquirer);             
                //this.acquirers.push(result_acquirer.data); 
                // console.log("result_acquirer", result_acquirer.data);  
                

                // //get data3
                if(result_acquirer.data.records != null && result_acquirer.data.records.length > 0) {
                    let u = 0;
                    for(u=0; u<result_acquirer.data.records.length; u++){                                                 
                    
                      // console.log("acquirer_id", result_acquirer.data.records[u].id);
                      let result_device = await axios.get(window.baseurl +"devices/acq/"+result_acquirer.data.records[u].id , 
                        {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
                      );
                      // console.log("devices_object", result_device); 

                      //
                      let objIndex = this.organizations.findIndex((obj => obj.orgId == result.data.records[i].id));
                      //this.organizations[objIndex].acquirer = "Laila"
                      // console.log("BIG ORGOANIZATION0000000", this.organizations[objIndex].acquirer);
                      let objIndex2 = this.organizations[objIndex].acquirer.findIndex((obj => obj.acquirerId == result_acquirer.data.records[u].id));
                      //console.log("BIG ORGOANIZATION1111111111111", this.organizations[objIndex].acquirer[objIndex2].device = "victor");
                      //this.organizations[objIndex].acquirer[objIndex2].device = result_device.data
                      this.organizations[objIndex].acquirer[objIndex2] = result_device.data.records            

                    }                   
                }         
                          
            }  
          
        }
        // console.log("BIG ORGOANIZATION", this.organizations);           
        
      },


      async pullDataNonAdmin(result){   
        
        //if(result.data != null && result.data.length > 0) {
            //let i = 0;
            this.organizations = [];   //remove all items from array
            //let org_id;
            //for(i=0; i<result.data.length; i++){                                                 
                
                // console.log("org_id", result.data.id);
                let result_acquirer = await axios.get(window.baseurl +"acquirers/org/"+result.data.id , 
                  {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
                );
                this.organizations.push({ orgId: result.data.id, orgName: result.data.orgName, acquirer: result_acquirer.data.records });
                // console.log("acquirers_object", result_acquirer);             
                //this.acquirers.push(result_acquirer.data); 
                // console.log("result_acquirer", result_acquirer.data);  
                

                // //get data3
                if(result_acquirer.data.records != null && result_acquirer.data.records.length > 0) {
                    let u = 0;
                    for(u=0; u<result_acquirer.data.records.length; u++){                                                 
                    
                      // console.log("acquirer_id", result_acquirer.data.records[u].id);
                      let result_device = await axios.get(window.baseurl+""+"devices/acq/"+result_acquirer.data.records[u].id , 
                        {"headers": {'Authorization': 'Bearer ' + this.accessToken}}
                      );
                      // console.log("devices_object", result_device); 

                      //
                      let objIndex = this.organizations.findIndex((obj => obj.orgId == result.data.id));
                      //this.organizations[objIndex].acquirer = "Laila"
                      // console.log("BIG ORGOANIZATION0000000", this.organizations[objIndex].acquirer);
                      // console.log("BIG objIndex", this.objIndex);
                      let objIndex2 = this.organizations[objIndex].acquirer.findIndex((obj => obj.acquirerId == result_acquirer.data.records[u].id));
                      // console.log("BIG objIndex2", this.objIndex2);
                      //console.log("BIG ORGOANIZATION1111111111111", this.organizations[objIndex].acquirer[objIndex2].device = "victor");
                      //this.organizations[objIndex].acquirer[objIndex2].device = result_device.data
                      this.organizations[objIndex].acquirer[objIndex2] = result_device.data.records            

                    }                   
                }         
                          
            //}  
          
        //}
        // console.log("BIG ORGOANIZATION", this.organizations);          
        
      },


    },
    

    async mounted(){

      this.checkTokenExpiry();  

      //
      let result;
      try{

        /* if(this.global_permissions.includes("ROLE_STAFF_ADMIN", 'ROLE_STAFF_USER')){
          result = await axios.get(window.baseurl+"organizations", {
              "headers": {'Authorization': 'Bearer ' + this.accessToken} 
            });
            
          
          this.pullDataAdmin(result)
          //this.$router.push({ path: `/devices/list` })
          this.$router.push({ path: `/devices-list` })
          
        } */ 
        if(this.global_permissions.includes("ROLE_USER_ADMIN", 'ROLE_VIEW_DEVICE')){
          result = await axios.get(window.baseurl+"organizations/"+this.orgId , {
              "headers": {'Authorization': 'Bearer ' + this.accessToken} 
            }); 
           
          
          this.pullDataNonAdmin(result)          
          //this.$router.push({ path: '/devices-list/'+this.orgId })
          this.$router.push({ path: '/device-org/'+this.orgId })
        }


        // console.log("organization_object1", result);
        
      }  
      catch (error){            
          this.show_toast(true, "warning", error.message);
      }

      
    }

  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }

  .routerLink{
     text-decoration: none;
     color: black;
 }

 
  </style>
  